import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import { ThemeProvider } from '../context/ThemeContext';
import ErrorBoundary from '../components/common/ErrorBoundary';
import App from '../App';
import reportWebVitals from '../reportWebVitals';
import '../index.css';
import '../assets/styles/market.css';
import '../css/responsive-overrides.css';
import '../css/auth-v2.css';
import '../css/product-cards.css';
import '../assets/styles/design-system.css';
import '../css/theme.css';
import '../css/responsive-polish.css';

export default function AppProviders() {
  return (
    <React.StrictMode>
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppProviders />);

reportWebVitals();
